import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/products', label: '商品一覧' },
    { path: '/philosophy', label: '私たちの想い' },
    { path: '/safety', label: '安心・安全への取り組み' },
    { path: '/company', label: '会社概要' },
    { path: '/contact', label: 'お問い合わせ' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || !isHomePage
            ? 'bg-white shadow-md'
            : 'bg-white/90 backdrop-blur-sm'
        }`}
      >
        {/* 上段：会社名（左）＋電話番号ボタン（右） */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-14">
            <Link
              to="/"
              className="text-base sm:text-lg lg:text-xl font-bold text-[#1A4D6D] hover:text-[#2A6D8D] transition-colors whitespace-nowrap"
            >
              おかやま健康製薬株式会社
            </Link>

            <div className="flex items-center gap-4">
              <a
                href="tel:086-012-3456"
                className="hidden sm:flex items-center gap-2 bg-[#1A4D6D] hover:bg-[#2A6D8D] text-white text-sm font-medium px-5 py-2 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-base w-4 h-4 flex items-center justify-center"></i>
                086-012-3456
              </a>
              <a
                href="tel:086-012-3456"
                className="sm:hidden w-10 h-10 flex items-center justify-center text-[#1A4D6D] hover:text-[#2A6D8D] transition-colors cursor-pointer"
                aria-label="電話する"
              >
                <i className="ri-phone-line text-xl"></i>
              </a>

              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden w-10 h-10 flex items-center justify-center text-[#1A4D6D] hover:text-[#4A90E2] transition-colors cursor-pointer"
                aria-label="メニュー"
              >
                <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* 下段：メニュー項目（中央配置） */}
        <div className="hidden lg:block border-t border-gray-100 bg-white">
          <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="flex items-center justify-center space-x-10 h-12">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm font-medium text-[#1A4D6D] hover:text-[#4A90E2] transition-colors relative group whitespace-nowrap"
                >
                  {link.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#4A90E2] transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="fixed inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
          <div className="fixed top-16 right-0 bottom-0 w-64 bg-white shadow-xl overflow-y-auto">
            <nav className="flex flex-col p-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-base font-medium text-[#1A4D6D] hover:text-[#4A90E2] transition-colors py-2 border-b border-gray-100"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  );
}